import { createContext, useContext } from "react";

import type { ThemeId } from "@/themes/registry";

export type ThemeProviderState = {
  theme: ThemeId;
  setTheme: (theme: ThemeId) => void;
};

const initialState: ThemeProviderState = {
  theme: "dark",
  setTheme: () => null,
};

export const ThemeProviderContext =
  createContext<ThemeProviderState>(initialState);

export const useTheme = () => {
  const context = useContext(ThemeProviderContext);

  if (context === undefined)
    throw new Error("useTheme must be used within a ThemeProvider");

  return context;
};
